module.exports = __webpack_public_path__ + "img/6.ba79bf55.png";